import { DoBoxEntryKind } from '@this+that/models';

// Brain reviews and signal confirmations share the backend's `__approvals__` bucket with flow approvals.
const APPROVAL_BAND_ENTRY_KINDS: ReadonlySet<DoBoxEntryKind> = new Set([
  DoBoxEntryKind.APPROVAL,
  DoBoxEntryKind.BRAIN_REVIEW,
  DoBoxEntryKind.BRAIN_SIGNAL_REVIEW,
]);

export function isApprovalBandEntryKind(
  entryKind: DoBoxEntryKind | null | undefined,
): boolean {
  return entryKind != null && APPROVAL_BAND_ENTRY_KINDS.has(entryKind);
}
